// utils/navigationConfig.js

import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import SchoolIcon from "@mui/icons-material/School";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SettingsIcon from "@mui/icons-material/Settings";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import DomainIcon from "@mui/icons-material/Domain";
import CrisisAlertIcon from "@mui/icons-material/CrisisAlert";
import LayoutDashboardIcon from "@mui/icons-material/Dashboard"; // Add this line (your original had this used but not imported)

const NAVIGATION_CONFIG = {
  admin: [
    { segment: "dashboard", title: "Dashboard", icon: <LayoutDashboardIcon /> },
    // { segment: 'staff', title: 'Staff', icon: <PeopleIcon /> },
    { segment: "students", title: "Students", icon: <SchoolIcon /> },
    { segment: "branches", title: "Branches", icon: <DomainIcon /> },
    { segment: "courses", title: "Courses", icon: <MenuBookIcon /> },
    // { segment: 'attendance', title: 'Attendance', icon: <CalendarMonthIcon /> },
    { segment: "requests", title: "Requests", icon: <CrisisAlertIcon /> },
    { segment: "uploads", title: "Uploads", icon: <UploadFileIcon /> },
    { segment: "profile", title: "Profile", icon: <SettingsIcon /> },
  ],
  staff: [
    { segment: "dashboard", title: "Dashboard", icon: <DashboardIcon /> },
    { segment: "students", title: "Students", icon: <SchoolIcon /> },
    { segment: "attendance", title: "Attendance", icon: <CalendarMonthIcon /> },
    { segment: "profile", title: "Profile", icon: <SettingsIcon /> },
  ],
  student: [
    { segment: "dashboard", title: "Dashboard", icon: <DashboardIcon /> },
    // {
    //   segment: "self-attendance",
    //   title: "Self Attendance",
    //   icon: <CalendarMonthIcon />,
    // },
    // { segment: "courses", title: "Courses", icon: <MenuBookIcon /> },
    { segment: "uploads", title: "Uploaded Files", icon: <UploadFileIcon /> },
    { segment: "profile", title: "Profile", icon: <SettingsIcon /> },
  ],
};

export function getNavigationForRole(role) {
  return NAVIGATION_CONFIG[role] || NAVIGATION_CONFIG.student;
}
